<template>
  <div v-show="isModalLocationVisible">
    <transition name="slide">
      <div class="modal-mask">
        <div class="modal-dialog modal-dialog-slideout modal-lg" >
          <div class="modal-content p-2">
            <div class="modal-header">
              <div class="width-100">
                <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                <button type="button" class="close float-right" @click="hide">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="modal-body">
              <div class="row mb-4">
                <div class="col-9 pl-3">
                  <div class="h3 d-inline mr-2 text-uppercase">Add New Location</div>
                  
                </div>
              </div>                            
              <form>
                <div v-if="firstPageActive">
                  <div class="row">
                    <div class="col-12">
                      <label class="form-label">Location Name</label>
                      <input type="text" id="account_name" class="col-12 col-sm-12 input-height-35 form-control" ref="account_name" name="account_name" v-model="company_name" v-validate="'required'" placeholder="Enter Location Name" maxlength="250" autocomplete="off">
                      <div v-if="verrors.firstByRule('account_name', 'required')" class="margin-bottom-5 validate-warning-msg">Location name is required</div>
                      <div v-if="verrors.firstByRule('account_name', 'exists')" class="margin-bottom-5 validate-warning-msg">Location name already exists</div>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-12">
                      <label class="form-label">Address</label>
                      <div class="row">
                        <div class="col-12">
                          <input type="text" id="address" class="col-12 col-sm-12 input-height-35 form-control" ref="address" name="address_one" v-model="address" placeholder="Address Line 1" maxlength="250" autocomplete="off">
                        </div>
                      </div>
                      <div class="row margin-t-10">
                        <div class="col-12">
                          <input type="text" id="address2" class="col-12 col-sm-12 input-height-35 form-control" ref="address2" name="address_two" v-model="address2" placeholder="Address Line 2" maxlength="250" autocomplete="off">
                        </div>
                      </div>
                      <div class="row margin-t-10">
                        <div class="col-4 col-sm-4">
                          <input type="text" id="account_city" class="col-12 col-sm-12 input-height-35 form-control" ref="account_city" name="account_city" v-model="city" placeholder="City" maxlength="100" autocomplete="off">
                        </div>
                        <div class="col-4 col-sm-4 p-0">
                          <b-form-select name="account_state" id="account_state" class="col-12 col-sm-12 input-height-35 form-control" v-model="state_code" :options="state_options">
                          </b-form-select>
                        </div>
                        <div class="col-4 col-sm-4">
                          <input type="text" name="account_zipcode" id="account_zipcode" class="col-12 col-sm-12 input-height-35 form-control" ref="zipcode" v-model="zip" placeholder="Zip Code" v-validate="{ rules: { regex: getPostalCodeRegex() } }" maxlength="10">
                          <div v-if="verrors.has('account_zipcode')" class="margin-bottom-5 validate-warning-msg">Postal code is invalid</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-12">
                      <label class="form-label">Primary Manager</label>
                      <div class="row">
                        <div class="col-6 col-sm-6">
                          <input type="text" id="admin_fname" class="col-12 col-sm-12 input-height-35 form-control" ref="admin_fname" name="admin_fname" v-model="admin_fname" v-validate="{ rules: { required: true, regex: nameRegex() } }" placeholder="First Name" maxlength="250" autocomplete="off">
                          <div v-if="verrors.firstByRule('admin_fname', 'required')" class="margin-bottom-5 validate-warning-msg">First name is required</div>
                          <div v-if="verrors.firstByRule('admin_fname', 'regex')" class="margin-bottom-5 validate-warning-msg">First name should only contain - and _</div>
                        </div>
                        <div class="col-6 col-sm-6 pl-0">
                          <input type="text" id="admin_lname" class="col-12 col-sm-12 input-height-35 form-control" ref="admin_lname" name="admin_lname" v-model="admin_lname" v-validate="{ rules: { required: true, regex: nameRegex() } }" placeholder="Last Name" maxlength="250" autocomplete="off">
                          <div v-if="verrors.firstByRule('admin_lname', 'required')" class="margin-bottom-5 validate-warning-msg">Last name is required</div>
                          <div v-if="verrors.firstByRule('admin_lname', 'regex')" class="margin-bottom-5 validate-warning-msg">Last name should only contain - and _</div>
                        </div>
                      </div>
                      <div class="row margin-t-10">
                        <div class="col-12">
                          <input type="text" id="admin_email" class="col-12 col-sm-12 input-height-35 form-control" ref="admin_email" name="admin_email" v-model="admin_email" v-validate="'required|email'" placeholder="Email Address" maxlength="250" autocomplete="off" @keyup.enter='enterSearchAction(index)'>
                          <div v-if="verrors.firstByRule('admin_email', 'required')" class="margin-bottom-5 validate-warning-msg">Email is required</div>
                          <div v-if="verrors.firstByRule('admin_email', 'email')" class="margin-bottom-5 validate-warning-msg">Email is invalid</div>
                          <div v-if="verrors.firstByRule('admin_email', 'exists')" class="margin-bottom-5 validate-warning-msg">Email address already exists</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-12">
                      <label class="form-label">Group</label>
                        <div class="row">
                          <div class="col-sm-12 col-md-12">
                            <div class="row">
                              <div class="col-sm-12 col-md-12">
                                <b-form-select class="col-12 col-sm-12 input-height-35 form-control" v-model="account_groups" name="group" :options="account_groups_options" placeholder="Select Group for New Account">           
                                </b-form-select>
                                <div v-if="verrors.firstByRule('group', 'required')" class="margin-bottom-5 validate-warning-msg">Group is required</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="lastPageActive">
                    <div class="row">
                      <div class="col-12">
                        <label class="form-label">
                          Account Status
                          <i class="ml-4 fa fa-question-circle-o"></i>
                        </label>
                        <div class="row">
                          <div class="col-2 col-sm-2">
                            <input type="radio" id="active" name="active" v-model="account_status" value="Active" @click="setAccountStatus('Active')">
                            <label for="active">Active</label>
                          </div>
                          <div class="col-2 col-sm-2">
                            <input type="radio" id="inactive" name="inactive" v-model="account_status" value="Inactive" @click="setAccountStatus('Inactive')">
                            <label for="active">Inactive</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-6">
                            <label class="form-label">Subscription Type</label>
                          </div>
                          <div class="col-3">
                            <label class="form-label text-center width-100">Quantity</label>
                          </div>
                          <div class="col-3">
                            <label class="form-label text-center width-100">Price</label>
                          </div>
                        </div>
                        <div class="row row_data_border" v-for="(pitem, sindex) in subscriptions" :key="sindex">
                          <div class="col-6">
                            <label :for="'subscription_plan_' + sindex">{{ pitem.name }}</label>
                          </div>
                          <div class="col-3">
                            <b-form-select class="col-12 col-sm-12 input-height-35 form-control" v-model="unit" name="unit" :options="qty_options" placeholder="Qty" @change="getPriceforSubscription">           
                            </b-form-select>
                          </div>
                          <div class="col-3 col-sm-3">
                            <label for="" class="text-center width-100"><span class="dollarsign" >$</span>&nbsp;{{ pitem.price }}/{{ pitem.validityDuration }}mo</label>
                          </div>
                        </div>
                        <div v-if="verrors.firstByRule('subscription_plan', 'required')" class="margin-bottom-5 validate-warning-msg">Subscription Type is required</div>
                        <div class="row">
                          <div class="col-9 col-sm-9"></div>
                          <div class="col-3 col-sm-3">
                            <button type="button" class="btn btn-sm btn-blue totalBtn text-center">
                              Total: <span class="total_price">${{ subscriptionTotal }}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-12">
                        <label class="form-label">Billing Information</label>
                    <div class="row">
                      <div class="col-12 col-sm-12">      
                      &nbsp;
                      </div>
                      <div class="col-12 col-sm-12">
                        <b-form-select class="col-12 col-sm-12 input-height-35 form-control" id="country_id" v-model="billingCountry" v-validate="'required'" name="billing_country" :options="country_options" v-on:change="getStateLists(billingCountry)" :disabled="(isAccessPlan) ? false: true">
                      </b-form-select>
                      <div v-if="verrors.firstByRule('billing_country', 'required')" class="margin-bottom-5 validate-warning-msg">Country is required</div>
                    </div>
                    <div class="col-12 col-sm-12 margin-t-10">
                        <input type="text" id="billingname" class="col-12 col-sm-12 input-height-35 form-control" ref="billingname" name="billingname" v-model="billingName" v-validate="{ rules: { regex: billingNameRegex(), required: true } }" placeholder="Billing Name" maxlength="250" autocomplete="off" :disabled="(isAccessPlan) ? false: true">
                        <div v-if="verrors.firstByRule('billingname', 'required')" class="margin-bottom-5 validate-warning-msg">Billing name is required</div>
                        <div v-if="verrors.firstByRule('billingname', 'regex')" class="margin-bottom-5 validate-warning-msg">Billing name should only contain - and _</div>
                      </div>
                    <div class="col-12 col-sm-12 margin-t-10">
                      <input type="text" class="col-12 col-sm-12 input-height-35 form-control" name="billing_address_1" placeholder="Billing Address 1" v-model="billingAddress" v-validate="'required'" :disabled="(isAccessPlan) ? false: true">
                      <div v-if="verrors.firstByRule('billing_address_1', 'required')" class="margin-bottom-5 validate-warning-msg">Billing Address 1 is required</div>
                    </div>                 
                    <div class="col-12 col-sm-12 margin-t-10">
                      <input type="text" class="col-12 col-sm-12 input-height-35 form-control" name="billing_address_2" placeholder="Billing Address 2" v-model="billingAddress2" :disabled="(isAccessPlan) ? false: true">
                    </div>
                    <div class="col-12 col-sm-12 margin-t-10">
                      <input type="text" name="phone number" id="phone_number" ref="phone_number" v-validate="{ rules: { regex: phoneRegex(), required: true } }" v-model="billingPhone" @keyup="billingPhoneValid" @blur="billingPhoneValid" class="col-12 col-sm-12 input-height-35 form-control" placeholder="Phone Number" :disabled="(isAccessPlan) ? false: true">
                      <div v-show="verrors.has('phone number')" class="validate-warning-msg">{{ verrors.first('phone number') }}</div>
                    </div>
                  </div>
                  <div class="row margin-t-10">
                    <div class="col-4 col-sm-4">
                      <input type="text" class="col-12 col-sm-12 input-height-35 form-control" name="billing_city" placeholder="City" v-model="billingCity" v-validate="'required'" :disabled="(isAccessPlan) ? false: true">
                      <div v-if="verrors.firstByRule('billing_city', 'required')" class="margin-bottom-5 validate-warning-msg">City is required</div>
                    </div>
                    <div class="col-4 col-sm-4">
                      <b-form-select class="col-12 col-sm-12 input-height-35 form-control" name="billing_state" v-model="billingState" v-validate="'required'" :options="state_options" :disabled="(isAccessPlan) ? false: true">
                      </b-form-select>    
                      <div v-if="verrors.firstByRule('billing_state', 'required')" class="margin-bottom-5 validate-warning-msg">State is required</div>
                    </div>
                    <div class="col-4 col-sm-4">
                      <input type="text" name="zip code" id="org_zip" ref="org_zip" v-validate="{ rules: { regex: getPostalCodeRegex(), required: true } }" v-model="billingZip" maxlength="10" class="col-12 col-sm-12 input-height-35 form-control" placeholder="Zip Code" :disabled="(isAccessPlan) ? false: true">
                      <div v-show="verrors.has('zip code')" class="validate-warning-msg">{{ verrors.first('zip code') }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-12">
                  <label class="form-label">Credit/Debit Card Information</label>
                  <div class="row">
                    <div class="col-sm-12 col-md-12">
                      <div class="row">
                        <div class="col-sm-12 col-md-12">
                          <input type="text" class="col-12 col-sm-12 input-height-35 form-control" name="card_no" v-model="cardNumber" v-validate="'required'" placeholder="Credit Card #" :disabled="(isAccessPlan) ? false: true">
                          <div v-if="verrors.firstByRule('card_no', 'required')" class="margin-bottom-5 validate-warning-msg">Card Number is required</div>
                        </div>
                      </div>
                      <div class="row margin-t-10">
                        <div class="col-sm-12 col-md-12">
                          <input type="text" class="col-12 col-sm-12 input-height-35 form-control" name="name_on_card" v-model="nameOnCard" v-validate="'required'" placeholder="Name on Card" :disabled="(isAccessPlan) ? false: true">
                          <div v-if="verrors.firstByRule('name_on_card', 'required')" class="margin-bottom-5 validate-warning-msg">Name on Card is required</div>
                        </div>
                      </div>
                      <div class="row margin-t-10">
                        <div class="col-4 col-sm-4">
                          <select class="col-12 col-sm-12 input-height-35 form-control" name="exp_month" v-model="expMonth" v-validate="'required'" :disabled="(isAccessPlan) ? false: true">
                            <option value="">Month</option>
                            <option value="01">01</option>
                            <option value="02">02</option>
                            <option value="03">03</option>
                            <option value="04">04</option>
                            <option value="05">05</option>
                            <option value="06">06</option>
                            <option value="07">07</option>
                            <option value="08">08</option>
                            <option value="09">09</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                          </select>
                          <div v-if="verrors.firstByRule('exp_month', 'required')" class="margin-bottom-5 validate-warning-msg">Month is required</div>
                        </div>
                        <div class="col-4 col-sm-4">
                          <b-form-select class="col-12 col-sm-12 input-height-35 form-control" name="exp_year" v-model="expYear" v-validate="'required'" :options="year_options" :disabled="(isAccessPlan) ? false: true">
                          </b-form-select>
                          <div v-if="verrors.firstByRule('exp_year', 'required')" class="margin-bottom-5 validate-warning-msg">Year is required</div>   
                        </div>
                        <div class="col-4 col-sm-4">
                          <input type="password" class="col-12 col-sm-12 input-height-35 form-control" name="cvv" placeholder="CVV" v-model="cvvValue" v-validate="'required'" :disabled="(isAccessPlan) ? false: true"
                          role="presentation"
                          autoComplete="new-password"
                          >
                          <div v-if="verrors.firstByRule('cvv', 'required')" class="margin-bottom-5 validate-warning-msg">CVV is required</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center m-2">
              <button type="button" class="btn btn-sm btn-blue ma-blue-btn text-center" @click="goToLastPage">{{ btnName }}</button>
            </div>
          </form>
        </div>
        <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </transition>

  <ActiveNewLocationModal 
      :isActiveNewLocationModalVisible="isActiveNewLocationModalVisible"
      :accountId="newAccountId"
      :invoice_filename="invoice_filename"
      :total="total"
      :cc4_digit="cc4_digit"
      ref="active_account_order"
      @close="close"
  />
  <InactiveNewLocationModal
      :isInactiveNewLocationModalVisible="isInactiveNewLocationModalVisible"
      :accountId="newAccountId"
      @close="close"
   />

   <AddNewAccountLicenseFailedModal
      :isAddNewAccountLicenseFailedModalVisible="isAddNewAccountLicenseFailedModalVisible"
      @close="close"
  />

  </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import VeeValidate from 'vee-validate';

import ActiveNewLocationModal from './active_new_location_modal.vue';
import InactiveNewLocationModal from './inactive_new_location_modal.vue';
import AddNewAccountLicenseFailedModal from  './addnew_account_license_failed_modal.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalLocationVisible', 'accountId'],
    data() {
        return {
            loading: false,
            firstPageActive: true,
            lastPageActive: false,
            btnName: 'Continue',
            company_name: '',
            address: '',
            address2: '',
            country_code: 'US',
            state_code: '',
            city: '',
            zip: '',
            market_area: '',
            admin_fname: '',
            admin_lname: '',
            admin_email: '',
            country_options: [],
            unit: 1,
            qty_options: [
              { value: '', text: 'Select' },
              { value: 1, text: 1 },
              { value: 2, text: 2 },
              { value: 3, text: 3 },
              { value: 4, text: 4 },
              { value: 5, text: 5 },
              { value: 6, text: 6 },
              { value: 7, text: 7 },
              { value: 8, text: 8 },
              { value: 9, text: 9 },
              { value: 10, text: 10 },
              { value: 11, text: 11 },
              { value: 12, text: 12 },
              { value: 13, text: 13 },
              { value: 14, text: 14 },
              { value: 15, text: 15 },
              { value: 16, text: 16 },
              { value: 17, text: 17 },
              { value: 18, text: 18 },
              { value: 19, text: 19 },
              { value: 20, text: 20 },
            ],
            licenseType: '',
            state_options: [
                { value: '', text: 'State' },
            ],
            status_options: [
                { value: '', text: 'Select Status' },
                { value: 'Active', text: 'Active' },
                { value: 'Inactive', text: 'Inactive' },
                { value: 'Prospect', text: 'Prospect' },
            ],
            account_status: 'Active',
            subscriptions: [],
            subscriptionId: '',
            subscription_plan: '',
            billingName: '',
            billingAddress: '',
            billingAddress2: '',
            billingCity: '',
            billingState: '',
            billingCountry: '',
            billingZip: '',
            billingPhone: '',
            nameOnCard: '',
            cardNumber: '',
            expMonth: '',
            expYear: '',
            cvvValue: '',
            year_options: [],
            subscriptionTotal: 0,
            isAccessPlan: 1,
            account_groups: '',
            account_groups_options: [],
            isActiveNewLocationModalVisible: false,
            isInactiveNewLocationModalVisible: false,
            newAccountId: '',
            invoice_filename: '',
            total: '',
            cc4_digit: '',
            isFormFillCompleted: false,
            close_url: '',
            page_from_purchasing: false,
            isAddNewAccountLicenseFailedModalVisible: false,
        }
    },
    components: {
        ActiveNewLocationModal,
        InactiveNewLocationModal,
        AddNewAccountLicenseFailedModal,
    },
    methods: {
        goBack() {
            this.verrors.clear();
            if (this.firstPageActive) {
                if (this.close_url) {
                    let routeData = this.$router.resolve({name: this.close_url});
                    window.open(routeData.href, '_self');
                } else {
                    if (this.page_from_purchasing) {
                        let routeData = this.$router.resolve({name: 'enterpriseadminpurchasing'});
                        window.open(routeData.href, '_self');
                    } else {
                        let routeData = this.$router.resolve({name: 'locations'});
                        window.open(routeData.href, '_self');
                    }
                }
            } else {
                this.lastPageActive = false;
                this.firstPageActive = true;
                this.btnName = 'Continue';
            }
        },
        hide() {
          this.close();
        },
        close() {
            this.verrors.clear();
            if (this.close_url) {
                let routeData = this.$router.resolve({name: this.close_url});
                window.open(routeData.href, '_self');
            } else {
                let routeData = this.$router.resolve({name: 'locations'});
                if (this.page_from_purchasing) {
                    if (this.firstPageActive) {
                        let routeData = this.$router.resolve({name: 'enterpriseadminpurchasing'});
                        window.open(routeData.href, '_self');
                    }
                } else {
                    if (this.firstPageActive) {
                        let routeData = this.$router.resolve({name: 'locations'});
                        window.open(routeData.href, '_self');
                    } else {
                        this.lastPageActive = false;
                        this.firstPageActive = true;
                        this.btnName = 'Continue';
                    }
                }
            } 
        },
        nameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        billingNameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        billingPhoneValid() {
            var billing_phone = this.billingPhone;
            this.billingPhone = billing_phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        phoneRegex() {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        getPostalCodeRegex() {
            return /^[0-9]{5}(?:-[0-9]{4})?$/;
        },
        getCountryLists() {
            axios.get('/get-country-lists', {

            })
            .then(response =>  {
                this.country_options = response.data;
            })
            .catch(function(error) {

            });
        },
        getStateLists(CountryCode) {
            axios.get('/get-state-lists/' + CountryCode, {

            })
            .then(response =>  {
                this.state_options = response.data;
            })
            .catch(function(error) {

            });
        },
        getExpiryYears() {
            this.year_options = [
                { value: '', text: 'Year' },
            ];       
            var min = new Date().getFullYear()
            var max = min + 20;
            for (var i = min; i <= max; i++) {
                var yoptions = { value: i, text: i };
                this.year_options.push(yoptions);
            }
        },
        setSubscriptionTotal(item) {
            this.subscriptionId = item.id;
            this.subscriptionTotal = item.price;
        },
        setAccountStatus(status) {
            this.isAccessPlan = (status == 'Active') ? true : false; 
            if (!this.isAccessPlan) {
                this.verrors.clear();
                this.btnName = 'Create Account';
            }
        },
        goToLastPage() {
            this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0) && this.firstPageActive == true) {
                    this.isFormFillCompleted = false;
                    this.createAccount();
                } else {
                    if ((this.verrors.items.length === 0) && this.lastPageActive == true) {
                        this.isFormFillCompleted = true;
                        this.createAccount();
                    }
                }
            });
        },
        getPriceforSubscription: function() {
          axios('/getsubscriptionPrice-new-location',
            {
              method: 'GET',
              params: {
                subscriptionId: this.subscriptionId,
                qty: this.unit,
              }
            }
          )
          .then(response => {
              this.subscriptions[0].price = response.data;
              if(this.licenseType == 'Bundle License') {
                this.subscriptionTotal = this.subscriptions[0].price;
              }
              else {
                this.subscriptionTotal = this.subscriptions[0].price * this.unit;
              }
              this.subscriptionPrice = response.data;
          })
          .catch(error => {

          });
        },

        getSubscriptionLists() {
            axios.get('/active-subscriptions-new-location/' + this.accountId + '/Single')
            .then((resp) => {
                this.loading = false;
                this.subscriptions = resp.data.subscriptions;

                this.licenseType = this.subscriptions[0].licenseType;
                this.unit = this.subscriptions[0].minQty;
                if(this.unit > 1) {
                    this.qty_options = [];
                    var qty =  { value: '', text: 'Select' };
                    this.qty_options.push(qty);
                    for(var i=this.unit; i < 21; i++) {
                        var qty = {value: i, text: i};
                        this.qty_options.push(qty);
                    }
                    this.subscriptionTotal = this.subscriptions[0].price;
                }
                else {
                    this.subscriptionTotal = this.subscriptions[0].price * this.unit;
                }

                this.subscriptionId = this.subscriptions[0].id;
                this.subscriptionPrice = this.subscriptions[0].price;
            })
            .catch(error => {

            });
        },
        createAccount() {
            axios('/enterprise-admin/add-new-location', 
            {
                method: 'POST',
                data: {
                    "account": {
                        "company_name": this.company_name,
                        "master_admin": false,
                        "school_flag": 0,
                        "website": '',
                        "phone_no": '',
                        "phone_ext": '',
                        "fax": '',
                        "status": this.account_status,
                        "naics_code": '',
                        "naics_id": '',
                        "naics_description": '',
                        "naics_label": '',
                        "researcher_notes": '',
                        "location": {
                            "address": this.address,
                            "address2": this.address2,
                            "country_code": 'US',
                            "state_code": this.state_code,
                            "city": this.city,
                            "zip": this.zip,
                            "market_area": this.market_area,
                        },
                        "program": 'Mentorship',
                    },
                    "userInfo": {
                        "uid": 0,
                        "admin_fname": this.admin_fname,
                        "admin_lname": this.admin_lname,
                        "admin_email": this.admin_email,
                        "admin_title": '',
                        "is_enabled": 0,
                        "is_manager": 1,
                        "is_news": 0,
                        "is_billingadmin": 0,
                        "is_primaryadmin": 1,
                        "admin_status": 'Active',
                        "id_number": '',
                        "password": '',
                        "mobile": '',
                        "phone": '',
                        "phone_ext": '',
                        "location_name": '',
                        "country": '',
                        "address": '',
                        "city": '',
                        "zip": '',
                        "state": '',
                        "market_area": '',
                        "remove_flag": false,
                        "last_login": '',
                        "no_login": '',
                        "is_mentee": 0,
                        "admin_courses": [],
                    },
                    "order": {
                        "subscription_id": this.subscriptionId,
                        "subscription_price": this.subscriptionPrice,
                        "total": this.subscriptionTotal,
                        "unit": this.unit,
                        "billing_name": this.billingName,
                        "billing_address": this.billingAddress,
                        "billing_address2": this.billingAddress2,
                        "billing_city": this.billingCity,
                        "billing_state": this.billingState,
                        "billing_country": this.billingCountry,
                        "billing_zip": this.billingZip,
                        "billing_phone": this.billingPhone,
                        "payment_method": 'credit_card',
                        "name_oncard": this.nameOnCard,
                        "card_number": this.cardNumber,
                        "exp_month": this.expMonth,
                        "exp_year": this.expYear.toString().substr(-2),
                        "cvv_value": this.cvvValue,
                    },
                    "account_groups": {
                        "group": this.account_groups
                    },
                    "isFormFillCompleted": this.isFormFillCompleted,
                },
            })
            .then((response) => {
                this.verrors.clear();
                if (response.data.first_step_only_completed) {
                    this.firstPageActive = false;
                    this.lastPageActive = true;
                    this.btnName = 'Create Account and Purchase';
                }
                if (response.data.second_step_completed) {
                    this.newAccountId = response.data.accountId;
                    if (response.data.order_msg != 'failed') 
                    {
                        if (this.account_status == 'Active') {
                            this.invoice_filename = response.data.invoice_filename;
                            this.$refs.active_account_order.page_from_purchasing = this.page_from_purchasing;
                            this.total = response.data.total;
                            this.cc4_digit = response.data.ccNumber4digit;
                            this.isActiveNewLocationModalVisible = true;
                        } else {
                            this.isInactiveNewLocationModalVisible = true;                    
                        }
                    } else  {
                        this.isAddNewAccountLicenseFailedModalVisible = true;
                    }
                }
            })
            .catch(error => {
                this.firstPageActive = true;
                this.lastPageActive = false;
                const fieldErrors =  [];
                const fieldErrors1 =  [];
                // var errMsgObj = error.response.data.message;
                var errMsgObj = JSON.parse(error.response.data.message);
                Object.keys(errMsgObj).map(key => {
                    if(key == 'account_name') {
                        var newFieldErr = {field:key, msg:errMsgObj[key], rule:'exists'};
                        fieldErrors1.push(newFieldErr);
                    }
                    else {
                        var newFieldErr = {field:key, msg:errMsgObj[key], rule:'exists'};
                        fieldErrors1.push(newFieldErr);
                    }
                });
                this.$validator.errors.add(fieldErrors1);
            });
        },
        getEnterpriseGroups() {
            if (this.accountId > 0) {
                axios('/enterprise-admin/groups/' + this.accountId,
                {
                    method: 'GET',
                })
                .then(response => {
                    var groupsCount = response.data.groups.length;
                    this.account_groups_options.push({ text:'Select Group for New Account', value: '' });
                    for (var m = 0; m < groupsCount; m++) {
                        this.account_groups_options.push({ 
                            text: response.data.groups[m].text, 
                            value: response.data.groups[m].value 
                        });
                    }
                })
                .catch(() => {
                });
            }
        },
        loadInitialData() {
            this.verrors.clear();
            this.getCountryLists();
            this.getStateLists('US');
            this.getSubscriptionLists();
            this.getExpiryYears();
            this.getEnterpriseGroups();
        }
    },
    created() {

    }
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}
@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.ma-blue-btn, .ma-blue-btn:hover, .ma-blue-btn:active, .ma-blue-btn:focus {
  color: #FFF; 
  border-radius: 10px;
  font-weight: 900;
  width: auto;
}
.totalBtn {
  color: #002F42; 
  background-color: #FFF !important;
  border: 1px solid #002F42 !important;
  border-radius: 10px;
  font-weight: 900;
  width: auto;
  padding: 10px;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;  
  background-color: #efefef;
  min-height: 38px;
}
.ma-input-field:focus-visible {
  outline: none;
}
.form-label { font-size: 13px; font-weight: 900; } 
.row_data_border { padding: 5px 0; margin-bottom: 5px; font-size: 14px;border-bottom: 1px solid rgba(0, 0, 0, 0.1); }
.row_data_border:nth-last-child(1) { border-bottom: 0 none; }
input, select {
    line-height: 17px;
    border-radius: 10px;
    padding-left: 5px !important;
    border: 1px solid #707070;
}
.back_icon { width: 14px; }
a, a:hover {
    text-decoration: none;
}

</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/add_new_location.vue